module.exports = __webpack_public_path__ + "static/media/logo-leclerc-2.05396431.svg";